<ng-content></ng-content>
<button class="carousel-nav carousel-nav--prev" *ngIf="index > 0" (click)="changeItem(index - 1)">
    <i class="icon-chevron-left"></i>
</button>
<button class="carousel-nav carousel-nav--next" *ngIf="index < itemCount - 1" (click)="changeItem(index + 1)">
    <i class="icon-chevron-right"></i>
</button>